import { userService } from '../_services'

const state = {
    reset: {},
    set: {},
    resetCapability: {
        loading: true,
        available: false
    }
}

const actions = {
    resetPassword ({ commit }, email) {
        commit('resetRequest')

        userService.resetPassword(email)
            .then(
                respnse => commit('resetSuccess', respnse.data.message),
                error => commit('resetFailure', error)
            )
    },
    checkResetCapability ({commit}) {
        commit('resetCapabilityRequest')
        return userService.hasResetCapability().then(
            response => commit('resetCapabilityResult', Boolean(response.data.result)),
            () => commit('resetCapabilityResult', false)
        )
    },
    setPassword ({commit}, {password}) {
        commit('setRequest')

        userService.setPassword(password)
            .then(
                response => commit('setSuccess', response.data.message),
                error => commit('setFailure', error)
            )
    }
}

const mutations = {
    resetRequest (state) {
        state.reset = { loading: true }
    },
    resetSuccess (state, message) {
        state.reset = {
            message: message
        }
    },
    resetFailure (state, error) {
        state.reset = { error }
    },
    resetCapabilityRequest (state) {
        state.resetCapability = { loading: true, available: false }
    },
    resetCapabilityResult (state, available) {
        state.resetCapability = { loading: false, available }
    },
    setRequest (state) {
        state.set = { loading: true }
    },
    setSuccess (state, message) {
        state.set = {
            message: message,
            complete: true
        }
    },
    setFailure (state, error) {
        state.set = { error }
    }
}

export const user = {
    namespaced: true,
    state,
    actions,
    mutations
}
